export let FirstMenuInteraction = {
  name: 'interaction',
  title: 'Manage interaction',
  shortcut: 'i'
}
